import React from "react";
import style from "styled-components";
import BUSDLogo from "../../../utils/svgs/busd-logo.png";
import ShinobiLogo from "../../../utils/svgs/shinobi-logo.png";

function CardHeader({stackingPool, amount}) {
  const lockedDay = stackingPool?.lockPeriod.toString() / (60 * 60 * 24);

  return (
    <CardHeaderContainer>
      <TextContainer>
        <CardHeaderPrimaryText>
          {stackingPool?.isFixed ? "Earn SHINO" : "Earn BUSD"}
        </CardHeaderPrimaryText>
        <CardHeaderSecondaryText>
          {lockedDay.toFixed(0)} days
        </CardHeaderSecondaryText>
      </TextContainer>
      {stackingPool?.isFixed ? (
        <PoolLogo src={ShinobiLogo} alt="" />
      ) : (
        <BUSDLogoComp src={BUSDLogo} alt="BUSD" />
      )}
    </CardHeaderContainer>
  );
}

export default CardHeader;

const CardHeaderContainer = style.div`
box-shadow: rgba(100, 0, 0, 0.25) 0px 14px 28px, rgba(100, 0, 0, 0.22) 0px 10px 10px;
 display:flex;
 justify-content: space-between;
 background-color: rgba(0, 0, 0, 0.80);
 border-top-right-radius: 20px;
 border-top-left-radius: 20px;
 padding:15px;
`;
const TextContainer = style.div`
  display: flex;
  flex-direction: column;
  margin-top:2px;
`;
const CardHeaderPrimaryText = style.span`
color: #fdfdfd;
font-size: 1.1rem;
font-weight: bold;
text-shadow: black 0px 0px 25px;
`;
const CardHeaderSecondaryText = style.span`
color: #fdfdfd;
font-size: 1rem;
margin-top:2px;
font-weight: 500;
text-shadow: black 0px 0px 25px;
`;
const BUSDLogoComp = style.img`
border-radius: 50%;
width: 3.5em;
height: 3.5em;
margin-top: -0.2rem;
filter: 
    drop-shadow(0px 0px 1.5px black);
`;

const PoolLogo = style.img`
width: 3.5em;
height: 3.5em;
margin-top: -0.2rem;
filter: 
    drop-shadow(0px 0px 1.5px black);
`;
